export default __webpack_public_path__ + "static/media/logo.a5cfbbec3df75f3a2ff96020845f14f5.svg";